import React from 'react';
import { TrendingDownIcon, ClockIcon, BanknoteIcon, BatteryLowIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { problems } from '../data/content';
const icons = [TrendingDownIcon, ClockIcon, BanknoteIcon, BatteryLowIcon];
export function ProblemSection() {
  return <section className="w-full bg-navy-800 py-3 lg:py-20" aria-labelledby="problem-heading" data-id="element-132" data-mp="2vqr69zq2hz5k">
      <div className="mx-auto max-w-7xl px-6 lg:px-8" data-id="element-133" data-mp="39hm8it629i06">
        <Reveal className="max-w-3xl" data-id="element-134" data-mp="39gb5ivkfwea4">
          <p className="text-sm font-bold uppercase tracking-widest text-brand-gold" data-id="element-135" data-mp="35gaor49vbqzw">The hard truth</p>
          <h2 id="problem-heading" className="mt-3 text-3xl font-black leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl" data-id="element-136" data-mp="3jftnx7kpbs02">
            Why traditional real estate methods are now dead
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-slate-300" data-id="element-137" data-mp="1p1iyoy072vtr">
            The agents taking your listings aren&rsquo;t working harder. They&rsquo;re running a different operating
            system — and the gap compounds every quarter you wait.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-138" data-mp="obyfcffvpano">
          {problems.map((problem, i) => {
          const Icon = icons[i];
          return <Reveal key={problem.stat} delay={i * 0.05} className="h-full" data-id="element-139" data-mp="x5juhzvygtxm" data-mpi={i}>
                <div className="flex h-full flex-col bg-navy-900 px-7 py-[7px] lg:py-7" data-id="element-140" data-mp="1244k75dkzv7t">
                  <Icon aria-hidden="true" className="h-7 w-7 text-brand-gold" strokeWidth={1.75} data-id="element-141" data-mp="172fsvcs53zog" />
                  <p className="mt-6 text-3xl font-black tracking-tight text-white" style={{
                marginTop: "2px",
                marginBottom: "2px"
              }} data-id="element-142" data-mp="1c2279pjpflyu">{problem.stat}</p>
                  <p className="mt-3 text-[15px] leading-relaxed text-slate-300" data-id="element-143" data-mp="1g2kzhkpieu1k">{problem.text}</p>
                </div>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}